module.exports = __webpack_public_path__ + "static/media/comments-default.d11c3a39.svg";